import React, { Component } from 'react';
import { Redirect } from 'react-router'
import { Field, reduxForm } from 'redux-form'
import Webcam from 'react-webcam';
import Category from '../containers/Category'
import ItemQueue from '../containers/ItemQueue'
import Menu from './Menu'
import MenuStyles from '../MenuStyles'

class SnapPhotoView extends Component {

  render() {

    let the_camera_id = window.getCookie("camera_id");
    let the_audio_id = window.getCookie("audio_id");

    //var w = window,
        //d = document,
        //e = d.documentElement,
        //g = d.getElementsByTagName('body')[0]
        //screen_width = w.innerWidth || e.clientWidth || g.clientWidth
        //screen_height = w.innerHeight|| e.clientHeight|| g.clientHeight;

    document.body.className = window.location.pathname.replace(/\//g," ");

    const setRef = (webcam) => {
      this.webcam = webcam;
    }

    const handleScreenShot = () => {
      const imageSrc = this.webcam.getScreenshot();
      this.props.addScreenShot(imageSrc);
    }

    const handleFile = (e) => {
      const self = this;
      const reader = new FileReader();
      let file = e.target.files[0];
      reader.onload = function(upload) {
        self.props.addScreenShot(upload.target.result);
      };
      reader.readAsDataURL(file);
    }

    if (this.props.current_user_id === undefined){
      return (<Redirect to="/" />)
    }else{

      if (this.props.draft_item.get("category_id") !== ""){
        return (

          <form onSubmit={this.props.handleSubmit}>
          <div className="bk-light">
            <div className="container topbar bk-dark">
             <div className="back"><a href="/" onClick={this.props.handleTitleBackClick}>« back</a></div>
              <div className="title">{this.props.category_name}</div>
            </div>
            <div className="padding-10x">
              <span className="p-relative">
                <label className="form-label">Title</label> <Field component="input" type="text" name="name" placeholder='Title' />
                <div className="input-clear" onClick={this.props.handleClearNameClick}>&times;</div>
              </span>

              <p><label className="form-label">Description</label> <Field component="textarea" name="description" placeholder='Add Item Description' /></p>

              <p><label className="form-label">Internal Notes</label> <Field component="textarea" name="internal_notes" placeholder='Add Internal Notes' /></p>

              {this.props.draft_item.get("submitting") === true ?
                <span>Submitting...</span>
                :
                <button>Post</button>
              }
            </div>
            </div>
          </form>
        )
      }else{

        return (
          <div>
              {this.props.current_user.get("deleting_an_item") === true ?
                <p>Deleting item...</p>
                :
                <Menu right styles={ MenuStyles } pageWrapId={ "page-wrap" } customBurgerIcon={ <img src="https://s3.amazonaws.com/public-staging.crowdfind.com/public/images/snapit/menu-white.svg" alt='' /> } >

                  { this.props.pending_item_ids.size !== 0 ?
                    <div>
                      <p className="queue-title">Pending</p>
                      <ul className="queue-list">
                        { this.props.pending_item_ids.map((pending_item_id) => {
                          let pending_item = this.props.pending_items.get(pending_item_id);
                          return (
                            <li className="flag" key={pending_item_id}>
                              <div className="flag-object">
                                <img className="item-queue-img" src={pending_item.image} alt="" />
                              </div>
                              <div className="flag-body item-queue-content">
                                <div className="item-queue-name">{pending_item.name}</div>
                              </div>
                              <div className="flag-object">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 128 128">
                                  <g>
                                    <path d="M75.4 126.63a11.43 11.43 0 0 1-2.1-22.65 40.9 40.9 0 0 0 30.5-30.6 11.4 11.4 0 1 1 22.27 4.87h.02a63.77 63.77 0 0 1-47.8 48.05v-.02a11.38 11.38 0 0 1-2.93.37z" fill="#aaaaaa" fillOpacity="1" />
                                    <animateTransform attributeName="transform" type="rotate" from="0 64 64" to="360 64 64" dur="1000ms" repeatCount="indefinite"></animateTransform>
                                  </g>
                                </svg>
                              </div>
                            </li>
                          )
                        })}
                      </ul>
                      </div>
                      :
                      ""
                    }
                  <ItemQueue />
                  <button className="logout" onClick={this.props.handleLogoutClick}>Logout</button>
                </Menu>
              }

            <div id="page-wrap" className="page-wrap">
              <form>
                {this.props.draft_item.get('image') !== "" ?
                  <div>
                    <div className="container topbar">
                      <div className="camera-back" style={{cursor:'pointer', fontWeight:"bold"}} onClick={this.props.clearDraftItemImage}>
                      </div>
                    </div>
                  <div className="content">
                      <img style={{maxWidth:"100%"}} alt="" src={this.props.draft_item.get('image')} />
                  </div>
                  <h2 className="centered light">Select category</h2>
                    <div className="swipeable category-scroll">
                      { this.props.categories.valueSeq().map((category) =>
                        <Category key={category.get("id")} id={category.get("id")} name={category.get("name")} icon_url={category.get("icon_url")} icon_white_url={category.get("icon_white_url")} />
                      )}
                  </div>
                </div>
                  :
                  (navigator.getUserMedia !== undefined ?
                    <div>
                      <div className="container topbar">
                      </div>
                      <div className="container-select bk-dark">
                        <Field component="select" id="venue_id" className="venue" name="venue_id" onChange={this.props.handleVenueChange}>
                          { this.props.venues.map((venue) => <option key={venue.id} value={venue.id}>{venue.name}</option>)
                          }
                        </Field>
                       </div>
                       <div className="camera-container">
                        <Webcam
                        audio={false}
                        ref={setRef}
                        screenshotFormat="image/jpeg"
                        audioSource={the_audio_id}
                        videoSource={the_camera_id}
                        height="100%"
                        width="100%"
                        className="camera-cam" />
                      </div>
                      <div className="padding-15x">
                        <div className="camera-button" onClick={handleScreenShot}>Capture photo »</div>
                      </div>
                    </div>
                    :
                    <div className="centered">
                      <h2 className="centered light padding-10x">Take/choose a photo:</h2>
                      <input className="centered light padding-10x" ref="file" type="file" accept="image/*" onChange={handleFile} />
                    </div>

                  )

                }

              </form>

            </div>

          </div>
        )

      }

    }
  }
}

export default reduxForm({form: "snap-photo", enableReinitialize: true})(SnapPhotoView);



// WEBPACK FOOTER //
// ./src/snapit_app/components/SnapPhotoView.js